import autoText from 'ui/autotext/custom.js';
import AbstractSelect from './abstract.js';
import config from './../../config.js';

const defaultValue = config.defaultArea;

export default class AreaSelect extends AbstractSelect {
    init(elements = {}) {
        super.init(elements);

        this.at = autoText.init(
            this.element,
            {
                type: 'custom',
                values: this.opts.areas || config.areas || defaultValue,
                requireData: true,
            },
            {
                onselect: ::this._onSelect,
                emptyselect: ::this._onDropSelect,
                ondrop: ::this._onDropSelect,
                beforeload: ::this._onBeforeLoad,
                open: ::this._onOpen,
            }
        );

        if (!this.at) {
            throw new Error('Area autotext init error');
        }

        this.element.on('keyup change', () => {
            this.error = false;
        });
        this.xhr = null;

        console.log('Area select init complete.');
    }

    load(city) {
        if (this.xhr) {
            this.xhr.abort();
        }

        this.xhr = $.ajax({
            method: 'GET',
            url: '/location/areas',
            data: { city },
            complete: () => {
                this.xhr = null;
            },
            success: (response = {}) => {
                const data = response;

                data.unshift(defaultValue);

                this.at.options.values = data;
                this.at.data(defaultValue);
            },
            error: (x, h, message) => {
                console.error(message);
            },
        });
    }

    clear() {
        this.at.options.values = [];
        this.drop();
    }
}
